export const asposeUnitsToMetric = (sizeInPoints, metricUnit) => {
  switch(metricUnit) {
    case ("inches"):
      return (sizeInPoints / 72).toFixed(2);
    default:
      return sizeInPoints;
  }
}
